import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton, ConfirmDeleteButton } from 'components/common';

interface Props {
  updateUsers: () => Promise<void>;
}

const AchievementCompletionsRemoveAll = ({ updateUsers }: Props) => {
  const {
    messages,
    pageState: { achievement },
    serverConfig: { requireReasonWhenDeletingData }
  } = useReduxState();

  const removeUsers = async (values?: { deletionReason?: string }) => {
    let url = `/admin/achievements/${achievement.id}/completions`;

    if (values?.deletionReason) {
      const params = new URLSearchParams({
        deletionReason: values.deletionReason
      });
      url += `?${params.toString()}`;
    }

    const response = await api.delete(url);
    if (!response.data || !response.data.success) return false;
    await updateUsers();

    return true;
  };

  return requireReasonWhenDeletingData ? (
    <ConfirmDeleteButton
      buttonIsDropdown={false}
      buttonText={messages.commonRemoveAll}
      confirmText={messages.achievementUsersRemoveAllConfirm}
      confirmTitle={messages.commonRemoveAllUsers}
      id="deletionReasonAchievementRemoveAll"
      onConfirm={removeUsers}
      successMessage={messages.commonRemoveAllUsersSuccess}
    />
  ) : (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonText={messages.commonRemoveAll}
      category="danger"
      confirmText={messages.achievementUsersRemoveAllConfirm}
      confirmTitle={messages.commonRemoveAllUsers}
      onConfirm={removeUsers}
      successMessage={messages.commonRemoveAllUsersSuccess}
    />
  );
};

export default AchievementCompletionsRemoveAll;
